define('constants/login-images',[], function() {
    var LoginImages = [
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/57d/2d6/1473785188_StickersAnimals091316_06.png",
            title: "bluebird"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/581/b69/1478211225_Young_sticker_animals110216_03.png",
            title: "turtle"
        },
        {
            src: "https://cdn.edu.buncee.com/assets/934763fd36c74918473d7292298cfced/stickersanimals110817-01.png",
            title: "penguin"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/571/d2d/1461703376_Young_sticker_animals042616_02.png",
            title: "camel"
        },
        {
            src: "https://cdn.edu.buncee.com/assets/7e0f73cf2f15432c9703e5625afa2a83/stickersanimals101317-01.png",
            title: "dog"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/568/912/1452118317_Young_sticker_animal010616_05.png",
            title: "starfish"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/581/696/1477667183_Young_sticker_animals102816_01.png",
            title: "alpaca"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/56a/736/1453945710_Young_sticker_animal012816_04.png",
            title: "flamingo"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/567/37b/1450391486_Young_Sticker_animal121715_01.png",
            title: "squirrel"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/581/146/1478104161_StickerAnimals110216_02.png",
            title: "ladybug"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/567/1c0/1450712072_Young_Sticker_animals121815_02.png",
            title: "deer"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/57a/2f8/1471033228_StickersAnimals081216_01.png",
            title: "butterfly"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/582/106/1479151721_Young-sticker_animal11416_01.png",
            title: "fox"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/57d/6ea/1473801898_Young_sticker_animals091316_01.png",
            title: "mouse"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/557/460/1434404361_Young_sticker_animal061515_01.png",
            title: "shark"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/567/6e1/1450733080_Young_sticker_animals122115_07.png",
            title: "cat"
        },
        {
            src: "https://cdn.edu.buncee.com/assets/3025ddcae3be7b3082cab80464b7b18c/sticker-animal090817-01.png",
            title: "hippo"
        },
        {
            src: "https://cdn.edu.buncee.com/assets/cb7691e000c53830549ad225844ad8df/stickersanimals071917-02.png",
            title: "pig"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/567/1c0/1450712072_Young_Sticker_animals121815_01.png",
            title: "hedgehog"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/56f/f5d/1458763221_Young_sticker_animals032316_02.png",
            title: "rabbit"
        },
        {
            src: "https://cdn.edu.buncee.com/assets/d8543b7f576742fbc5c033538263dd23/stickersanimals091317-01.png",
            title: "elephant"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/582/8c7/1479511162_Young_sticker_Young_sticker_animal111816_01mal111816_01.png",
            title: "fish"
        },
        {
            src: "https://cdn.edu.buncee.com/assets/06ccd60f00eb62ed8c27c01ee1d18ddd/stickersanimals091517-01.png",
            title: "brownbear"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/56d/6d8/1456958853_Young_sticker_animal030216_07.png",
            title: "frog"
        },
        {
            src: "https://cdn.edu.buncee.com/rackspace/bnc-assets/stickers/57d/46c/1473791693_StickersAnimals091316_07.png",
            title: "skunk"
        }
    ];

    LoginImages.__proto__.findTitle = function(title) {
        return _.find(LoginImages, function(loginImage) {
            return loginImage.title === title
        });
    }

    return LoginImages;
});
